module.exports = __webpack_public_path__ + "static/img/androidcode.28970f9b.png";